import { jsx as e } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import { B as n } from "../Button-D6KC5041.js";
const s = i(({ active: r, isRounded: t = !0, ...o }, a) => /* @__PURE__ */ e(
  n,
  {
    "aria-pressed": r,
    "data-state": r ? "on" : "off",
    ref: a,
    rounded: t,
    variant: r ? "active" : "tertiary",
    ...o
  }
));
s.displayName = "Pill";
export {
  s as Pill
};
